import * as React from "react";
import { FormattedMessage } from "react-intl";
// components
import Icon from "common/icons";
import SolidButton from "common/components/solidButton";
// styles

const styles = require("./profileDefaultHeader.scss");

const profileHeader = () => {
  return (
    <div className={styles.headerWrapper}>
      <div className={styles.wallPaper}>
        <div className={styles.placeHolderImage} />
      </div>
      <div className={styles.userInfoWrapper}>
        <div className={styles.profileImageWrapper}>
          <div className={styles.placeHolderImage} />
        </div>

        <div className={styles.leftWrapper}>
          <div className={styles.userInfo}>
            <div className={styles.username}>
              <span />
              <span className={styles.traitIconWrapper} />
              <span className={styles.userMenu}>
                <Icon icon="DOWN_ARROW" />
              </span>
            </div>
          </div>

          <SolidButton
            buttonText=""
            disabled={false}
            className={styles.button}
            buttonStyle={{
              backgroundColor: "rgba(0,0,0,0)",
            }}
          />
        </div>

        <div className={styles.userScoreWrapper}>
          <div className={styles.scoreItem}>
            <div className={styles.score}>-</div>
            <div className={styles.scoreTitle}>
              <FormattedMessage id="profile.following_text" />
            </div>
          </div>
          <div className={styles.rightDivide} />
          <div className={styles.scoreItem}>
            <div className={styles.score}>-</div>
            <div className={styles.scoreTitle}>
              <FormattedMessage id="profile.follower_text" />
            </div>
          </div>
          <div className={styles.rightDivide} />
          <div className={styles.scoreItem}>
            <div className={styles.score}>-</div>
            <div className={styles.scoreTitle}>
              <FormattedMessage id="profile.boost_text" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default profileHeader;
